// extracted by mini-css-extract-plugin
export default {"button":"menu-item__button___QrH5n base__button___zT0JW"};